
import React from 'react'

export default props => (
  <span
    className="logoutBtn roundButton"
    style={{
      width: '25px',
      height: '28px',
      display: 'block',
      padding: '0px 0 0 3px',
      transform: 'translate(0, -0.1em)',
    }}
  >
    <svg
      {...props}
      className="MuiSvgIcon-fontSizeMedium MuiBox-root css-1om0hkc"
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M15 15C14.4477 15 14 15.4477 14 16C14 16.5523 14.4477 17 15 17H22.865L20.7439 19.8477C20.3904 20.272 20.4477 20.9025 20.872 21.2561C21.2962 21.6097 21.9268 21.5523 22.2804 21.1281L25.7682 16.6402C26.0773 16.2693 26.0773 15.7307 25.7682 15.3598L22.4084 11C22.0548 10.5757 21.4243 10.5184 21 10.872C20.5757 11.2255 20.5184 11.8561 20.872 12.2804L22.865 15H15Z" fill="#3F89CD" />
      <path d="M11 8C9.89543 8 9 8.89543 9 10V22C9 23.1046 9.89543 24 11 24H18C18.5523 24 19 23.5523 19 23C19 22.4477 18.5523 22 18 22H11V10H18C18.5523 10 19 9.55229 19 9C19 8.44772 18.5523 8 18 8H11Z" fill="#3F89CD" />
      <path fillRule="evenodd" clipRule="evenodd" d="M16 0C24.8366 0 32 7.16344 32 16C32 24.8366 24.8366 32 16 32C7.16344 32 0 24.8366 0 16C0 7.16344 7.16344 0 16 0ZM16 2C23.732 2 30 8.26801 30 16C30 23.732 23.732 30 16 30C8.26801 30 2 23.732 2 16C2 8.26801 8.26801 2 16 2Z" fill="#3F89CD" />
    </svg>

  </span>
)
